<template>
  <v-container style="margin-top: -10px">
    <v-form
      ref="form"
      lazy-validation
      class="app-form"
      @submit.prevent="onSubmit"
    >
      <v-expansion-panels class="app-expansion-panels">
        <v-expansion-panel>
          <v-expansion-panel-header class="app-expansion-panel-header mb-0">
            <h4 class="text">
              <v-icon>filter_alt</v-icon>
              <span>Filtrar</span>
            </h4>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="app-expansion-panel-content">
            <v-row class="mt-3">
              <v-col
                :lg="6"
                :md="6"
                :sm="6"
                :xs="6"
              >
                <MonthFilterPicker @mesAno="(valor) => onChangeMesAno(valor)" />
              </v-col>
              <v-col
                v-if="!isGrupoMunicipio"
                :lg="6"
                :md="6"
                :sm="6"
                :xs="6"
              >
                <v-text-field
                  v-model="table.paginate.qtdeUnAbastecimentoAgua"
                  :clearable="true"
                  label="Quantidade de Unidades Usuária do Serviço de Abastecimento de Água"
                  placeholder="Ex:. 1.000"
                  outlined
                  dense
                  @input="formatIntegerFilter('qtdeUnAbastecimentoAgua')"
                />
              </v-col>
              <v-col
                v-if="!isGrupoMunicipio"
                :lg="6"
                :md="6"
                :sm="6"
                :xs="6"
              >
                <v-text-field
                  v-model="table.paginate.qtdeUnEsgotamentoSanitario"
                  :clearable="true"
                  label="Quantidade de Unidades Usuária do Serviço de Esgotamento Sanitário"
                  placeholder="Ex:. 1.000"
                  outlined
                  dense
                  @input="formatIntegerFilter('qtdeUnEsgotamentoSanitario')"
                />
              </v-col>
              <v-col
                v-if="!isGrupoMunicipio"
                :lg="6"
                :md="6"
                :sm="6"
                :xs="6"
              >
                <v-text-field
                  v-model="table.paginate.faturamentoMensalLiquido"
                  v-currency
                  :clearable="true"
                  label="Faturamento Direto Mensal Líquido"
                  placeholder="Ex:. 1.000,00"
                  outlined
                  dense
                />
              </v-col>
              <v-col
                :lg="6"
                :md="6"
                :sm="6"
                :xs="6"
              >
                <v-autocomplete
                  v-model="table.paginate.situacao"
                  :items="itemsSituacoes"
                  item-text="descricao"
                  item-value="nome"
                  :clearable="true"
                  label="Situação"
                  outlined
                  dense
                  multiple
                />
              </v-col>
              <v-col
                :lg="6"
                :md="6"
                :sm="6"
                :xs="6"
              >
                <v-autocomplete
                  v-model="table.paginate.situacaoDae"
                  :items="itemsSituacoesDAE"
                  item-text="descricao"
                  item-value="nome"
                  :clearable="true"
                  label="DAE"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <div class="mt-3 d-flex">
              <v-spacer />
              <v-btn
                outlined
                color="error"
                type="button"
                class="mr-2"
                @click.prevent.stop="clearFilter"
              >
                <v-icon size="14">
                  delete
                </v-icon>Limpar Filtros
              </v-btn>
              <v-btn
                depressed
                color="primary"
                type="submit"
              >
                Filtrar
              </v-btn>
            </div>
            <div id="endForm" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-form>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MonthFilterPicker from "@/views/gessan/Saneamento/components/MonthFilterPicker.vue";
import SaneamentoService from "@/services/gessan/saneamento.service";
import AuthService from "@/services/gessan/auth.service";
import FunctionsCommuns from "@/util/FunctionsCommuns";

const actions = mapActions("gessan", [
  "setTableContent",
  "setTableIsLoading",
  "setTableTotals",
  "clearTable",
]);
const state = mapState("gessan", ["table"]);
const global = mapState("global", ["userGessan"]);

export default {
  components: { MonthFilterPicker },
  data: () => ({
    itemsSituacoes: [],
    itemsSituacoesDAE: [],
  }),
  computed: {
    ...state,
    ...global,
    isGrupoMunicipio() {
      return !!this.userGessan?.isGrupo;
    },
  },
  mounted() {
    this.getSituacoes();
    this.getSituacoesDAE();
  },
  methods: {
    formatIntegerFilter(field) {
      const value = this.table.paginate[field];

      if (!value) {
        return;
      }

      const normalizedValue = value.toString().replace(/\D/g, "");

      this.table.paginate[field] = normalizedValue
        ? FunctionsCommuns.IntegerFormatTextField(normalizedValue)
        : null;
    },
    getSituacoes() {
      SaneamentoService.getSituacoes(
        this.userGessan.cnpj,
        this.userGessan?.isGrupo
      ).subscribe({
        next: (response) => {
          const { result } = response;
          this.itemsSituacoes = result;
        },
        error: (error) => {
          AuthService.globalStore("error", "Erro ao buscar por Situações");
        },
      });
    },
    onChangeMesAno(value) {
      this.table.paginate.mesAno = value;
    },
    async onSubmit() {
      await this.search();
      this.$vuetify.goTo("#endForm");
    },
    clearFilter() {
      this.clearTable();
      this.search();
    },
    search() {
      this.setTableIsLoading(true);
      const situacao = this.table.paginate.situacao
        ? this.table.paginate.situacao.join(";")
        : "";
      const paginate = {
        ...this.table.paginate,
        situacao,
        cnpj: this.userGessan.cnpj,
        qtdeUnAbastecimentoAgua: this.isGrupoMunicipio
          ? null
          : this.table.paginate.qtdeUnAbastecimentoAgua,
        qtdeUnEsgotamentoSanitario: this.isGrupoMunicipio
          ? null
          : this.table.paginate.qtdeUnEsgotamentoSanitario,
        faturamentoMensalLiquido: this.isGrupoMunicipio
          ? null
          : this.table.paginate.faturamentoMensalLiquido,
      };
      SaneamentoService.getList(paginate, this.userGessan?.isGrupo).subscribe(
        ({ result }) => {
          this.setTableContent(result?.data);
          this.setTableTotals(result.totalElements);
          this.setTableIsLoading(false);
        },
        (error) => {
          this.setTableIsLoading(false);
        }
      );
    },
    getSituacoesDAE() {
      SaneamentoService.getSituacoesDAE(
        this.userGessan.cnpj,
        this.userGessan?.isGrupo
      ).subscribe({
        next: (response) => {
          const { result } = response;
          this.itemsSituacoesDAE = result;
        },
        error: (error) => {
          AuthService.globalStore("error", "Erro ao buscar por Situações");
        },
      });
    },
    ...actions,
  },
};
</script>
